import { styled } from '@mui/material';

import { rem, Theme } from '../../theme';
import { Heading } from '../Heading';

export const StyledInfoContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => theme.typography.text_19};
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: ${theme.tggSpacing(rem(1.5), 3.75)};
        margin-bottom: ${theme.tggSpacing(rem(1), 2.5)};
        background-color: ${theme.palette.grey[50]};
        border-radius: ${theme.tggSpacing(rem(0.8), 2)};
        ${theme.breakpoints.up('desktop')} {
            margin-bottom: ${theme.tggSpacing(rem(2), 5)};
        }
    `}
`;

export const StyledHeaderSection = styled('div')<{ $isClosed?: boolean }>`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: ${({ $isClosed }: { $isClosed?: boolean }) => ($isClosed ? `${theme.tggSpacing(0, 0)}` : `${theme.tggSpacing(rem(0.4), 1)}`)};
        ${theme.breakpoints.up('desktop')} {
            margin-bottom: ${({ $isClosed }: { $isClosed?: boolean }) => ($isClosed ? `${theme.tggSpacing(0, 0)}` : `${theme.tggSpacing(rem(0.8), 2)}`)};
        }
    `}
`;

export const StyledHeader = styled(Heading)`
    ${({ theme }: { theme: Theme }) =>
        theme.typography.text_14_bold_desktop_16};
    color: ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
`;

export const StyledIconButton = styled('button')`
    ${({ theme }: { theme: Theme }) => `
        padding: ${theme.tggSpacing(0, 0)};
        cursor: pointer;
        background-color: transparent;
        border: none;
    `}
`;
